export const rules = {
  required: (required = true) => ({ required, message: 'Required field' }),
};
